import env from 'utils/env';
export default function parseProjectionPoint(data) {
    var _a, _b, _c;
    // The API returns `photo` wrapped in an extra pair of quote characters (see the same
    // workaround in Playground.tsx and CommentCreator.tsx), so it must be unwrapped before
    // being turned into a URL, otherwise the image fails to load.
    const photo = (data === null || data === void 0 ? void 0 : data.photo) ? `${env.static}/${data.photo.slice(1, -1)}` : '';
    const component = data === null || data === void 0 ? void 0 : data.component;
    const componentId = (component === null || component === void 0 ? void 0 : component.id) || '';
    const componentName = (component === null || component === void 0 ? void 0 : component.label) || '';
    const componentCategoryLabelPL = ((_a = component === null || component === void 0 ? void 0 : component.productCategory) === null || _a === void 0 ? void 0 : _a.typeLabelPL) || '';
    const componentCategoryLabelEN = ((_b = component === null || component === void 0 ? void 0 : component.productCategory) === null || _b === void 0 ? void 0 : _b.typeLabelEN) || '';
    const componentCategoryIcon = ((_c = component === null || component === void 0 ? void 0 : component.productCategory) === null || _c === void 0 ? void 0 : _c.typeIcon) || '';
    return Object.assign(Object.assign({}, data), { photo,
        componentId,
        componentName,
        componentCategoryLabelPL,
        componentCategoryLabelEN,
        componentCategoryIcon });
}
